import React, { useCallback } from 'react';
import {
    SearchOutlined,
    useBreakpoint,
    Image,
    ClockOutlined,
} from '@landr/maestro';
import {
    ContentSuggestionPayload,
    SuggestionsType,
    getSuggestionDisplayType,
} from 'components/Filters/context/SearchBarContext/types';
import { getImageUrl } from 'helpers';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';

const useContentSuggestionItem = ({
    deleteUserRecentSearch,
    suggestionType,
    modifiers,
    isHovered,
}: {
    deleteUserRecentSearch: (modifiers: ContentSuggestionPayload[]) => void;
    suggestionType: SuggestionsType;
    modifiers: ContentSuggestionPayload;
    isHovered: boolean;
}) => {
    const { applySuggestion } = useSearchBarContext();

    const [params, { name, artworkUrl }] = modifiers;
    const displayableFiltersParams = getSuggestionDisplayType();
    const filterCategories = params && displayableFiltersParams[params];

    const handleClick = useCallback(() => {
        applySuggestion(modifiers);
    }, [modifiers, applySuggestion]);

    const isRecentSuggestion = suggestionType === SuggestionsType.Recent;
    const isMobile = useBreakpoint('md');
    const isRemoveSuggestionVisible =
        isRecentSuggestion && (isMobile || isHovered);

    const handleRemoveRecentSuggestion = useCallback(
        (event: React.MouseEvent) => {
            event.stopPropagation();
            modifiers && deleteUserRecentSearch([modifiers]);
        },
        [deleteUserRecentSearch, modifiers],
    );

    const icon = isRecentSuggestion ? (
        <ClockOutlined size="sm" />
    ) : (
        <Image
            width="20px"
            height="20px"
            borderRadius="xs"
            src={getImageUrl({
                imageUrl: artworkUrl,
                width: 40,
            })}
            fallback={<SearchOutlined size="sm" />}
        />
    );

    const isNavigationItem =
        suggestionType !== SuggestionsType.Recent && isHovered;

    return {
        filterName: name,
        icon,
        isNavigationItem,
        isRemoveSuggestionVisible,
        filterCategories,
        handleClick,
        handleRemoveRecentSuggestion,
    };
};

export default useContentSuggestionItem;
